import React from 'react';
import Content from '../../components/Pages/auth/DirectSignOn';
import DirectAuthLayout from '../../components/Layout/Auth/DirectAuthLayout';

function DirectSignOnGuidance() {
  document.title = 'Guidance: Direct Sign On';

  return (
    <DirectAuthLayout>
      <Content />
    </DirectAuthLayout>
  );
}

export default DirectSignOnGuidance;
